module.exports = "img/flags/DM.31eb095.png";